export default __webpack_public_path__ + "static/media/christmas.49ac517f.gif";